<div [style.fontSize]="size" class="hestia-logo">
    <i class="icon-ergo_hestia">
        <span class="path1"></span>
        <span class="path2"></span>
    </i>
</div>
